import {createAction} from "redux-actions";

export const addDataAction = createAction('ADD_DATA');
export const removeDataAction = createAction('REMOVE_DATA');
export const updateDataAction = createAction('UPDATE_DATA');



// WEBPACK FOOTER //
// ./app/client/_data/actions.ts